<template>
  <router-link :to="{name: 'add-campaign'}">
    <div class="brand-card">
    <div class="brand-card-header bg-facebook">
      <i class="fa fa-envelope"></i>
      <div class="chart-wrapper">
        <social-box-chart-example chartId="box-chart-01" :data="[65, 59, 84, 84, 51, 55, 40]" />
      </div>
    </div>
    <div class="brand-card-body">
      <div>
        <div class="text-value">
            Add
        </div>
        <div class="text-uppercase text-muted small">
            Campaign
        </div>
      </div>
    </div>
  </div>
  </router-link>
</template>

<script>
    export default {
        name: "AddCampaignWidget"
    }
</script>

<style scoped>

</style>
